import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

import * as APIDashboard from "../../../services/nps/functions";

import NpsEvolution from "./NpsEvolution/NpsEvolution";
import NpsLevel from "./NpsLevel/NpsLevel";
import NpsDateOne from "./NpsDateOne/NpsDateOne";
import NpsDateTwo from "./NpsDateTwo/NpsDateTwo";
import NpsDateThree from "./NpsDateThree/NpsDateThree";
import ClassificationZoneProfileMap from "./ClassificationZoneProfileMap/ClassificationZoneProfileMap";
import NpsDateFour from "./NpsDateFour/NpsDateFour";
import NpsDateFive from "./NpsDateFive/NpsDateFive";
import Negotiations from "./Negotiations/Negotiations";

import "./dashboard.css";

export default function Dashboard() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [npsValue, setNpsValue] = useState(0);
  const [midias, setMidias] = useState([]);
  const [isLoadingSurveyInfos, setIsLoadingSurveyInfos] = useState(false);
  const [surveyInfosFromDateOne, setSurveyInfosFromDateOne] = useState({
    enviadas: "0",
    respondidas: 0,
    clientes: 0,
    porcentagemClientes: 0,
    tempMedio: "0",
  });
  const [loadingPieChartData, setLoadingPieChartData] = useState(false);

  async function getMidias() {
    const response = await APIDashboard.getMidias();

    if (response && response.status !== 200) return;

    if (response && response.status === 200) {
      setMidias(response.data);
    }
  }

  useEffect(() => {
    getMidias();
  }, []);

  return (
    <article className="nps-dashboard">
      <NpsEvolution />

      <NpsLevel
        setLevel={setNpsValue}
        setLoadingPieChartData={setLoadingPieChartData}
      />

       <NpsDateOne
        setIsLoadingSurveyInfos={setIsLoadingSurveyInfos}
        setSurveyInfosFromDateOne={setSurveyInfosFromDateOne}
      />

      <NpsDateTwo />

      <NpsDateThree
        npsValue={npsValue}
        loadingPieChartData={loadingPieChartData}
      />

      <ClassificationZoneProfileMap
        surveyInfosFromDateOne={surveyInfosFromDateOne}
        isLoadingSurveyInfos={isLoadingSurveyInfos}
      />

      <NpsDateFour />

      <NpsDateFive midias={midias} />

      <Negotiations />
    </article>
  );
}
